import { useAuth } from "../contexts/AuthContext";
import { AlertTriangle, Sparkles, ShieldAlert } from "lucide-react";
import { Button } from "./ui/button";

export default function TrialBanner({ onUpgrade }) {
  const { user } = useAuth();
  if (!user) return null;

  if (user.funnel_state === "active" || user.funnel_state === "lifetime") return null;

  if (user.funnel_state === "trial") {
    return (
      <div
        data-testid="trial-banner-active"
        className="w-full bg-teal/10 border-b border-teal/30 text-white/90 text-[13px] py-2 px-4 flex items-center justify-center gap-3"
      >
        <Sparkles className="h-3.5 w-3.5 text-teal" />
        <span className="font-mono tracking-wide">
          FREE TRIAL ACTIVE • <span className="text-teal font-semibold">{user.days_remaining}</span> DAYS REMAINING
        </span>
        <button
          data-testid="trial-upgrade-link"
          onClick={onUpgrade}
          className="ml-3 text-teal hover:text-white underline underline-offset-4"
        >
          Upgrade now
        </button>
      </div>
    );
  }

  if (user.funnel_state === "nag") {
    return (
      <div
        data-testid="trial-banner-nag"
        className="w-full text-white text-[13px] py-2.5 px-4 flex items-center justify-center gap-3 border-b"
        style={{ background: "rgba(255,87,34,0.18)", borderColor: "rgba(255,87,34,0.5)" }}
      >
        <AlertTriangle className="h-4 w-4" style={{ color: "#FF5722" }} />
        <span className="font-semibold tracking-tight">
          Your trial period has expired. Add payment details to maintain uninterrupted access.
        </span>
        <Button
          data-testid="nag-upgrade-btn"
          size="sm"
          onClick={onUpgrade}
          className="ml-3 h-7 bg-orange-alert hover:bg-orange-alert/90 text-white border-0 rounded-sm"
        >
          Add Payment
        </Button>
      </div>
    );
  }

  if (user.funnel_state === "payment_locked") {
    return (
      <div
        data-testid="trial-banner-payment-locked"
        className="w-full bg-red-critical/15 border-b border-red-critical/40 text-white text-[13px] py-2.5 px-4 flex items-center justify-center gap-3"
      >
        <ShieldAlert className="h-4 w-4 text-red-critical" />
        <span className="font-semibold">Payment failed — account locked. Update payment to restore access.</span>
        <Button
          data-testid="payment-locked-update-btn"
          size="sm"
          onClick={onUpgrade}
          className="ml-3 h-7 bg-red-critical hover:bg-red-critical/90 text-white border-0 rounded-sm"
        >
          Update Card
        </Button>
      </div>
    );
  }

  return null;
}
